import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions } from './ManagedCloudServiceFormOptions';

export const getManagedCloudServiceFormData = (target, helpWith) => {
  let namespace: string;
  const subject = `HPE MFY : ${helpWith} - {formId}`;
  const category = `HPE Managed Cloud Services ${helpWith}`;

  switch (helpWith) {
    case helpWithOptions.iaasBlock:
      namespace = 'hpe_mfy_iaas_block';
      break
    case helpWithOptions.vcf:
      namespace = 'hpe_mfy_vcf';
      break
    case helpWithOptions.rhoe:
      namespace = 'hpe_mfy_rhoe';
      break
    default:
      namespace = 'hpe_mfy_iaas_block'
      break
  }

  return getSortedFormFields(target, namespace, subject, category);
};
